import React, { useState } from 'react'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import Partners from '../../partials/Partners'
import AboutSummary from './components/AboutSummary/AboutSummary'
import LinkCards from '../../partials/LinkCards/LinkCards'
import Background from '../../assets/backgrounds/homepage.svg'
import BackgroundMobile from '../../assets/backgrounds/homepage-mobile.svg'
import NewEra from './components/Solution/NewEra'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'
import News from './components/News'
import Reimagined from '../Applications/components/Reimagined/Reimagined'
import PartnerWithUs from '../Partnerships/components/PartnerWithUs'

const HomePage = () => {
    const [padding, setPadding] = useState<PaddingProps>()

    return (
        <PaddingContext.Provider value={{ padding }}>
            <div className='relative'>
                <PageHeader
                    title='page.homepage.title'
                    description='page.homepage.description'
                    bgColor={Color.PURPLE}
                    className='md:min-h-screen'
                    component={Background}
                    mobileComponent={BackgroundMobile}
                />
                <div className='bg-white'>
                    <Partners>
                        <div className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                            <div className='w-full h-px bg-black/10' />
                        </div>
                    </Partners>
                    <PartnerWithUs />
                    <Reimagined />
                    {/* <AboutSummary setPadding={setPadding} /> */}
                    <NewEra />

                    <News />
                    <LinkCards
                        title1='section.linkCard.contactUs'
                        link1='/contact'
                        title2='page.careers.become'
                        link2='https://careers.biomatter.ai/'
                        external2={true}
                    />
                </div>
            </div>
        </PaddingContext.Provider>
    )
}

export default HomePage
